import {
  Grid,
  FormControl,
  Box,
  Typography,
  TextareaAutosize,
  Tooltip,
  Skeleton,
  TextField,
  Autocomplete,
  Badge,
} from "@mui/material";
import React, { useRef, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import Base from "../../Base/views/Base";
import CommonDatePicker from "../../Base/views/CommonDatePicker";
import MaterialTable, { MTableToolbar } from "material-table";
import "jspdf-autotable";
import CommentIcon from "@mui/icons-material/Comment";
import { ConvertDate, getUserData } from "../../Base/helper/baseFunctions";
import { PayPeriodDateHelper } from "../../Finance/helper/Reports/GetWageReportHelper";
import { AddEmployeeCanteenManagementAction, DeleteEmployeeCanteenManagementAction, GetEmployeeCanteenManagementAction, UpdateEmployeeCanteenManagementAction } from "../../../../store/Employee/Canteen/Action";
import SelectableMultiSelect from "../../Base/views/SelectableMultiSelect";
import { GetAccessWorkLocationAction } from "../../../../store/Ancillary/WorkLocation/Action";
import CanteenTeamSizeExceededWarningPopup from "../helpers/TeamSizeValPopup";
import BackdropMeepl from "../../Ancillary/AnimationComponents/BackdropMeepl";
import { GetCanteenTeamSizeUtilizedHelper } from "../helpers/TokenConfigHelper";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const EmployeeTokenConfigGrid = () => {
  const dispatch = useDispatch();
  const date = new Date();
  const canteenTeamSizeRef = useRef();
  const [paydate, setPayDate] = useState(null);
  const [canteenTeamSize, setCanteenTeamSize] = useState(null);
  const { tokenConfigLoading, tokenConfigData } = useSelector(
    (state) => state?.EmployeeReducer?.EmployeeCanteenReducer
  );
  const { company_logo } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const currentDate = new Date();
  const formattedToday = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-${currentDate.getDate().toString().padStart(2, "0")}`;

  const [filters, setFilters] = useState({
    month_year: `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}`,
    ats_work_location_id: []
  });
  const fetchCanteenTeamSize = () => {
    GetCanteenTeamSizeUtilizedHelper().then(res => {
          if(res?.data?.statuscode === 200) {
            const resData = res?.data?.data?.[0]
            setCanteenTeamSize(resData?.fn_get_canteen_team_size_utilized)
          }
     });
  }
  useEffect(() => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    dispatch(
      GetEmployeeCanteenManagementAction({
        month: f_month,
        year: f_year,
        ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null 
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters]);
  useEffect(() => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    PayPeriodDateHelper({
      month: String(f_month),
      year: String(f_year),
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setPayDate(res?.data?.data?.[0]);
      }
    });
    dispatch(GetAccessWorkLocationAction());
    fetchCanteenTeamSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSubmitRowData = (rowData, actionType) => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    const basicData = {
      company_logo,
      formattedToday
    }
    if (actionType === "edit") {
      if(rowData?.employee_canteen_tokens_maping_id) {
        dispatch(
          UpdateEmployeeCanteenManagementAction({
            ...rowData,
            employee_fk: rowData?.employee_id,
            month: f_month,
            year: f_year,
            record_date: rowData?.record_date,
            ...basicData
          })
        );
      } else {
        if (canteenTeamSizeRef?.current) {
          canteenTeamSizeRef?.current.validateAIConfig(canteenTeamSize).then(res => {
            if(res.ok){
              const companyName = getUserData().company_full_name?.toUpperCase() || ""
              dispatch(
                AddEmployeeCanteenManagementAction({
                  ...rowData,
                  employee_fk: rowData?.employee_id,
                  uuid: generateShortUUID(companyName),
                  month: f_month,
                  year: f_year,
                  record_date: rowData?.record_date
                    ? convertDateFormat(rowData?.record_date)
                    : formattedToday,
                  ...basicData
                }, (error, result) => {
                  if (!error && result?.data?.statuscode === 200) {
                    fetchCanteenTeamSize();
                  }
                })
              );
            }
          })
        };

      }
    } else if (actionType === "delete") {
      dispatch(
        DeleteEmployeeCanteenManagementAction({
          employee_canteen_tokens_maping_id: rowData?.employee_canteen_tokens_maping_id,
          month: f_month,
          year: f_year,
        })
      );
    } else {
      console.log("Invalid action type:", actionType);
    }
  };

  const convertDateFormat = (date) => {
    // always accept argument as new Date() object
    if (!date) return "";
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  };

  const handleFilter = (event, value) => {
    if (["month_year"].includes(event?.target?.name)) {
      setFilters({ ...filters, [event?.target?.name]: event?.target?.value });
    }
  };
  const titleContent = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Employee
      </Typography>
      <Typography variant="body2" color="text.secondary">
        <span>
            Configure meal token to employees&nbsp;
            <Tooltip title="Organization Canteen Capacity: Indicates the unallocated portion of the organization’s canteen token capacity, applicable to both employees and visitors." placement="bottom" arrow>
                <Badge
                  badgeContent={canteenTeamSize || "0"}
                  color="secondary"
                  overlap="circular"
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.6rem",
                      height: 14, 
                      minWidth: 14,
                      top: 3,
                      right: -8,
                      padding: "0 3px",  
                    },
                    cursor: "pointer",
                  }}
                >
                  <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer", marginBottom: "4px" }} />
                </Badge>
            </Tooltip>
        </span>
      </Typography>
    </Box>
  );
  const { workLocationAccess_options } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
  const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
    const handleWorkLoacation = () => {
        if(workLocationAccess_options) {
            setWorklocationData({ load: false, values: workLocationAccess_options || [] })
        } else {
            setWorklocationData({ load: false, values: [] })
        }
    }
    useEffect(() => {
        handleWorkLoacation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[workLocationAccess_options])
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
        }
    }
  return (
    <Base>
      <Box
        sx={{
          maxHeight: "calc(100vh - 65px)",
          overflowY: "auto",
        }}
      >
        <Grid
          pt={2}
          pb={1}
          container
          justifyContent="space-between"
          alignItems="center"
          pr={2}
        >
          <Grid item>
            <FormControl>
              <CommonDatePicker
                name="month_year"
                openTo="month"
                views={["year", "month"]}
                label="Month and Year"
                pickerType="date"
                size="small"
                onKeyDown={(e) => e.preventDefault()}
                onKeyPress={(e) => e.preventDefault()}
                pickerFormat="MM/yyyy"
                DefaultDTvalue={filters.month_year}
                maxDate={
                  new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() + 2,
                    1
                  )
                }
                minDate={
                  new Date(
                    new Date(minDojYear).setFullYear(
                      new Date(minDojYear).getFullYear() - 1
                    )
                  )
                }
                handleChange={(value) =>
                  handleFilter({
                    target: {
                      name: "month_year",
                      value: value
                        ? `${value?.getFullYear()}-${(
                            "0" +
                            (value?.getMonth() + 1)
                          ).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                        : "",
                    },
                  })
                }
              />
            </FormControl>
          </Grid>
          <Grid item>
            {paydate?.start_date ? (
              <Box textAlign="right">
                <Typography
                  variant="body2"
                  color="text.secondary"
                  textAlign={"start"}
                >
                  Pay Period
                </Typography>
                <Typography variant="subtitle1" fontWeight={600}>
                  {ConvertDate(paydate?.start_date)} -{" "}
                  {ConvertDate(paydate?.end_date)}
                </Typography>
              </Box>
            ) : (
              <Box textAlign="right">
                <Skeleton variant="text" width={100} height={12} />
                <Skeleton variant="text" width={80} height={20} />
              </Box>
            )}
          </Grid>
        </Grid>
        <Box sx={{position: "relative"}}>
          <MaterialTable
            isLoading={tokenConfigLoading}
            columns={[
              {
                title: "Employee",
                headerStyle: {
                  width: "25%",
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "25%",
                  textAlign: "start",
                  padding: "0px 0px 0px 2%",
                },
                field: "employee_name",
                grouping: false, 
                editable: "never", 
                filtering: false,               
              },
              {
                title: "Location",
                field: "work_location_name",
                editable: "never", 
                filtering: false,
                headerStyle: {
                  width: "20%",
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "20%",
                  textAlign: "start",
                  padding: "0px 0px 0px 2%",
                },
                render: (rowData) => rowData?.work_location_name ?? "N/A"
              },
              {
                title: "Token/Month",
                field: "tokens",
                headerStyle: {
                  width: "20%",
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "20%",
                  textAlign: "start",
                  padding: "0px 0px 0px 4%",
                },
                validate: (rowData) => {
                  if (rowData?.tableData?.editing === "delete") return "";
                  const value = rowData?.tokens;

                  if (value === "" || value === null || value === undefined) {
                    return "Token cannot be empty";
                  }

                  if (isNaN(value) || rowData?.tokens === "") {
                    return "Token cannot be empty";
                  }
                  if (value < 0) {
                    return "Token must be greater than 0";
                  }
                  return "";
                },
                render: (rowData) => Number(rowData?.tokens) === 100 ? "Unlimited" : rowData?.tokens || '0',

                editComponent: (props) => {
                  // const rowData = props.rowData || {};
                  // const balanceRaw = rowData?.token_balance;
                  const handleChange = (event, newValue) => {
                    if (newValue === "Unlimited") {
                      props.onChange("100"); 
                    } else if (/^\d*$/.test(newValue)) {
                      props.onChange(newValue ? Number(newValue) : "");
                    }
                  };

                  const displayValue =
                    Number(props?.value) === 100
                      ? "Unlimited"
                      : props?.value?.toString() || "";

                  return (
                    <Box sx={{ width: "100%", pb: 0.5, ml: "-50px" }}>
                      <Autocomplete
                        freeSolo
                        disableClearable
                        options={["Unlimited"]}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option?.label || ""
                        }
                        value={displayValue}
                        onChange={(e, newValue) => handleChange(e, newValue)}
                        onInputChange={(e, newInputValue, reason) => {
                          if (reason === "input") {
                            handleChange(e, newInputValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            fullWidth
                            required
                            placeholder="Enter Count or Unlimited"
                            inputProps={{
                              ...params.inputProps,
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                              onKeyDown: (event) => {
                                const allowedKeys = [
                                  "Backspace",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Delete",
                                  "Tab",
                                ];
                                if (
                                  !/[0-9]/.test(event.key) &&
                                  !allowedKeys.includes(event.key)
                                ) {
                                  event.preventDefault();
                                }
                              },
                            }}
                          />
                        )}
                        sx={{
                          "& input::placeholder": {
                            fontSize: "12px",
                            color: "#aaa",
                          },
                        }}
                      />
                    </Box>
                  );
                },
              },
              {
                title: "Token Balance",
                field: "token_balance",
                editable: "never", 
                filtering: false,
                headerStyle: {
                  width: "15%",
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "15%",
                  textAlign: "start",
                  padding: "0px 0px 0px 4%",
                },
                render: (rowData) => {
                  if (Number(rowData?.token_balance) === 100) {
                    return "Unlimited";
                  }
                  return rowData?.token_balance ?? "-";
                }
              },
              {
                title: "Comment",
                headerStyle: {
                  width: "20%",
                  textAlign: "center",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  width: "20%",
                  textAlign: "center",
                  padding: "5px 0px 0px 2%",
                },
                field: "comments",
                grouping: false,
                sorting: false,
                render: (rowData) => {
                  return (
                    <Box width={"90%"}>
                      <Tooltip title={rowData.comments || ""} arrow>
                        <CommentIcon
                          sx={{
                            fontSize: "20px",
                            color: rowData.comments ? "#637381" : "#95a0ab",
                            cursor: rowData.comments ? "pointer" : "default",
                          }}
                        />
                      </Tooltip>
                    </Box>
                  );
                },
                editComponent: (props) => {
                  return (
                    <Box width={"100%"}>
                      <TextareaAutosize
                        minRows={1}
                        maxRows={1}
                        placeholder={"Comment"}
                        value={props.value || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 50) {
                            props.onChange(value);
                          }
                        }}
                        style={{
                          width: "100%",
                          borderRadius: "5px",
                          padding: "8px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                          border: "1px solid #ccc",
                          resize: "none",
                        }}
                      />

                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          textAlign: "right",
                          color: "#888",
                        }}
                      >
                        {props.rowData?.comments?.length || 0}/50
                      </Typography>
                    </Box>
                  );
                },
              },
            ]}
            data={tokenConfigData}
            options={{
              maxBodyHeight: "calc(100vh - 235px)",
              minBodyHeight: "calc(100vh - 235px)",
              rowStyle: { fontSize: "13px", height: "30px" },
              headerStyle: {
                padding: "7px 0px 7px 0px",
                fontWeight: "bold",
              },
              sorting: true,
              search: true,
              searchText: "",
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              searchFieldVariant: "standard",
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              paginationPosition: "bottom",
              exportButton: false,
              exportAllData: false,
              addRowPosition: "first",
              selection: false,
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              grouping: false,
              columnsButton: false,
            }}
            icons={{
              Edit: () => <EditIcon sx={{ color: "#637381" }} />,
              // Delete: () => <DeleteIcon sx={{ color: "#637381" }} />,
            }}
            editable={{
              onRowUpdate: (newRow, oldRow) =>
                new Promise((resolve, reject) => {
                  if (
                    !newRow?.tokens
                  ) {
                    return reject();
                  }
                  handleSubmitRowData(newRow, "edit");
                  setTimeout(() => resolve(), 500);
                }),
              // onRowDelete: (selectedRow) =>
              //   new Promise((resolve, reject) => {
              //     handleSubmitRowData(selectedRow, "delete");
              //     setTimeout(() => resolve(), 1000);
              //   }),
            }}
            components={{
                Toolbar: (props) => (
                    <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                        <Box
                            sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            backgroundColor: "#f3edfd",
                            padding: "0px 0px 0px 20px",
                            flexGrow: 1,
                            minHeight: "48px !important",
                            }}
                        >
                        <Box>
                            <Typography variant='h6'>
                                {titleContent}
                            </Typography>
                        </Box>
                        <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                            <SelectableMultiSelect
                                multiple
                                label="Location"
                                placeholder="Select Location"
                                value={filters?.ats_work_location_id}
                                loading={handleWorkLoacation}
                                fieldLabel="work_location_name"
                                name="ats_work_location_id"
                                size="small"
                                onChangeEvent={handleFilterChange}
                                data={worklocationData}
                                menuHeight={150} // optional
                            />
                        </Box> 
                        </Box>
                        <Box
                            sx={{
                                "& .MuiToolbar-root": {
                                padding: "12px 16px !important",
                                margin: "auto !important",
                                minHeight: "48px !important",
                                },
                                "& .MuiFormControl-root": {
                                margin: "0 !important",
                                },
                                "& .MuiInputBase-root": {
                                marginLeft: "-20px !important",
                                }
                            }}
                            >
                                <MTableToolbar {...props} />
                            </Box>
                        </Box>
                ),
                Overlay: () => null,
                OverlayLoading: () => <BackdropMeepl open={true} dark={false}/>,
            }}
            title={""}
          />
          <CanteenTeamSizeExceededWarningPopup ref={canteenTeamSizeRef} closeReq={true} />
        </Box>
      </Box>
    </Base>
  );
};
export function generateShortUUID(companyName = "") {
  const prefix = companyName
    .replace(/[^a-zA-Z0-9]/g, "")
    .substring(0, 5)
    .toUpperCase();

  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let random = "";

  // Ensure at least one number
  const number = Math.floor(Math.random() * 10).toString();
  random += number;

  for (let i = 1; i < 6; i++) {
    random += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  // Shuffle so the number isn't always first
  random = random
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");

  return `${prefix}#${random}`;
}


export default EmployeeTokenConfigGrid;
